export default __webpack_public_path__ + "static/media/WEB_MD.791dc526.png";